/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Notes_LabelInputs */



/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Event_Notes_Notes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_notes_label = /** @type {((inputs?: Event_Notes_Notes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Notes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmerkungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Note")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примечания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("笔记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("注記")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notas")
	return /** @type {LocalizedString} */ ("Notes")
});